import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../products/services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsignmentService } from '../../services/consignment.service';
import { ConsignmentProductService } from '../../services/consignment-product.service';
import { ProductConsignmentStatusService } from '../../../configuration/services/product-consignment-status.service';
import { ConsignmentProductStatusService } from '../../services/consignment-product-status.service';

import htmlDocx from 'html-docx-js/dist/html-docx';
import * as FileSaver from 'file-saver';
import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import { PersonService } from '../../../person/services/person.service';
declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
  selector: 'app-view-consignment',
  templateUrl: './view-consignment.component.html',
  styleUrls: ['./view-consignment.component.css'],
  providers:[ProductService,ConsignmentService,ConsignmentProductService,ProductConsignmentStatusService,PersonService,ConsignmentProductStatusService]
})
export class ViewConsignmentComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  person: any = {};
  productLoaded : boolean = false;
  consignment: any = {
    total_consignment_amount:0
  };
  consignmentProducts: any = [];
  productConsignmentStatuses: any = [];
  selectedConsignmentProduct: any = {};
  productConsignmentStatus: any = {};
  role:number = 3;

  constructor(private consignmentProductService: ConsignmentProductService, private productService:ProductService, private consignmentService: ConsignmentService,
    private route: ActivatedRoute, private router: Router, private productConsignmentStatusService:ProductConsignmentStatusService,
    private personService:PersonService, private consignmentProductStatusService:ConsignmentProductStatusService) { }

  ngOnInit() {
    this.getProductConsignmentStatuses();
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getConsignment();
      }
    });
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductConsignmentStatuses(){
    this.productConsignmentStatusService.query({}).subscribe((productConsignmentStatuses) => {
      this.productConsignmentStatuses = productConsignmentStatuses;
    });
  }

  addAnotherProduct(){
    this.productLoaded = false;
  }

  handlePersonSelected($event){
    if ($event.id != undefined){
      this.consignment.person = $event;
      //TODO maybe this line will be remove
      this.person = $event;
      //Copy fields from person to entity
      this.copyPersonData(this.person, this.consignment);
    }
  }

  copyPersonData(person, entity){
    entity['nif'] = person.nif;
    entity['name'] = person.name;
    entity['surname'] = person.surname;
    entity['address'] = person.address;
    entity['cp'] = person.cp;
    entity['town'] = person.town;
    entity['state'] = person.state;
    entity['born_date'] = person.born_date;
  }

  handleAddProduct($event){
    $event.stock = $event.stock > 0?$event.stock:1;
    this.consignment.total_consignment_amount += $event.purchase_price;
    this.saveConsignment().then((consignment) =>{
      this.saveProductAndRelationToConsignment($event);
    });
    this.productLoaded = true;
  }

  getConsignment(){
    this.consignmentProducts = [];
    this.consignmentService.get(this.id).subscribe((consignment) => {
      this.consignment = consignment;
      this.person = consignment.person;
      this.consignment.createdByNameAndSurname = this.consignment.createdBy.name +" "+ this.consignment.createdBy.surname;
      this.consignment.naturalCreatedAt = moment(this.consignment.createdAt).format("DD-MM-YYYY HH:mm");
      this.consignment.nameAndSurname = this.person.name +" "+ this.person.surname;
      let params ={
        consignment: consignment.id
      }
      this.consignmentProductService.query(params).subscribe((consignmentProducts) =>{
        consignmentProducts.forEach(consignmentProduct=>{
          this.consignmentProducts.push(consignmentProduct);
          consignmentProduct.product.naturalDescription = "";
          if (consignmentProduct.product.type=="1" ){
               if(consignmentProduct.product.sub_type=="1"){
                consignmentProduct.product.naturalDescription += "Tipo:Móvil"+", ";
                }
              if(consignmentProduct.product.sub_type=="2"){
               consignmentProduct.product.naturalDescription += "Tipo:Tablet"+", ";
              }  
            }
            if(consignmentProduct.product.type=="2"){
               consignmentProduct.product.naturalDescription += "Tipo:Consolas"+", ";
            }
            if(consignmentProduct.product.type=="3"){
               consignmentProduct.product.naturalDescription +="Cantidad:"+consignmentProduct.product.stock+", "+consignmentProduct.product.naturalDescription; 
            }
            if (consignmentProduct.product.type=="4" ){
               if(consignmentProduct.product.sub_type=="1"){
                consignmentProduct.product.naturalDescription += "Tipo:PC"+", ";
                }
              if(consignmentProduct.product.sub_type=="2"){
              consignmentProduct.product.naturalDescription += "Tipo:Portatil"+", ";
              }  
            }
          if (consignmentProduct.product.brand){
            consignmentProduct.product.naturalDescription += "Marca:"+consignmentProduct.product.brand+", ";
          }
          if (consignmentProduct.product.model){
            consignmentProduct.product.naturalDescription += "Modelo:"+consignmentProduct.product.model+", ";
          }
          if (consignmentProduct.product.telephone_company){
            consignmentProduct.product.naturalDescription += "Operador:"+consignmentProduct.product.telephone_company+", ";
          }
          if (consignmentProduct.product.storage_capacity){
            consignmentProduct.product.naturalDescription += "Capacidad:"+consignmentProduct.product.storage_capacity+", ";
          }
          if (consignmentProduct.product.status){
            consignmentProduct.product.naturalDescription += "Estado:"+consignmentProduct.product.status+", ";
          }
          if (consignmentProduct.product.imei){
            consignmentProduct.product.naturalDescription += "Imei:"+consignmentProduct.product.imei+", ";
          }
          if (consignmentProduct.product.imei2){
            consignmentProduct.product.naturalDescription += "Imei2:"+consignmentProduct.product.imei2+", ";
          }
          if (consignmentProduct.product.so){
            consignmentProduct.product.naturalDescription += "Sistema Operativo:"+consignmentProduct.product.so+", ";
          }
          if (consignmentProduct.product.ram){
            consignmentProduct.product.naturalDescription += "Ram:"+consignmentProduct.product.ram+", ";
          }
          if (consignmentProduct.product.description){
            if (consignmentProduct.product.type != "3"){
              consignmentProduct.product.naturalDescription += "Descripción:"+consignmentProduct.product.description+", ";
            }else{
              consignmentProduct.product.naturalDescription += "Descripción:"+consignmentProduct.product.description+", ";
            }
          }
          if (consignmentProduct.product.serial_number){
            consignmentProduct.product.naturalDescription += "Número de serie:"+consignmentProduct.product.serial_number+", ";
          }
          if (consignmentProduct.product.stock == undefined){
              consignmentProduct.product.stock =  '';
            }
            if (consignmentProduct.product.purchase_price == undefined){
              consignmentProduct.product.purchase_price =  '';
            }
            if (consignmentProduct.product.sale_price == undefined){
              consignmentProduct.product.sale_price =  '';
            }
          consignmentProduct.product.naturalDescription = consignmentProduct.product.naturalDescription.slice(0, -2);
          consignmentProduct.product.naturalDescription = consignmentProduct.product.naturalDescription + "; "
        });
        this.productLoaded = true;
        if (this.consignment.barcode){
          setTimeout( ()=>{
            JsBarcode("#barcode",this.consignment.barcode,{format: "ean13"});
            this.consignment.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
          },0)
        }
      })
    });
  }

  saveProductAndRelationToConsignment(product){
    this.saveProduct(product).then((productSaved) =>{
      this.saveConsignmentProduct(productSaved).then((consignmentProduct)=>{
        consignmentProduct['product'] = productSaved ; 
        this.consignmentProducts.push(consignmentProduct);
        this.getConsignment();
      });
    });
  }


  saveConsignmentProduct(product){
    return new Promise((resolve, reject) => {
      this.consignmentProductService.create(this.returnConsignmentProductProperties(product,this.consignment))
      .subscribe((consignmentProduct) => {
        this.consignmentProductStatusService.create(this.returnConsignmentProductStatusProperties(consignmentProduct, product))
          .subscribe((consignmentProductStatus) => {
            resolve(consignmentProduct);
        });
      });
    });
  }

  saveConsignment(){
    return new Promise((resolve, reject) => {
      if (this.consignment.id == undefined){
        this.generateBarcodeNumber(this.consignment.nif,this.consignment.person.id).then((barcode)=>{
          this.consignment.barcode = barcode;
          this.consignmentService.create(this.returnConsignmentProperties(this.consignment))
          .subscribe((consignment) => {
            this.consignmentService.get(consignment.id).subscribe((consignment) => {
              this.consignment = consignment;
              this.id = consignment.id;
              resolve();
            });
          });
        });
      }else{
        this.consignmentService.update(this.returnConsignmentProperties(this.consignment))
        .subscribe((consignment) => {
          this.consignment = consignment;
          resolve();
        });
      }
    });
  }
  saveProduct(product){
    return new Promise((resolve, reject) => {
      if (product.id == undefined){
        this.productService.create(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve(product);
        });
      }else{
        this.productService.update(this.returnProductProperties(product))
        .subscribe((product) => {
          resolve();
        });
      }
    });
  }
  deleteConsignmentProduct(consignmentProduct){
    if(window.confirm('¿Está seguro de borrar este producto?')){
      this.consignmentProductService.delete(consignmentProduct.id)
      .subscribe(() => {
        this.productService.delete(consignmentProduct.product.id)
        .subscribe(() => {
        this.getConsignment();
        });
      });
    }
  }

  returnConsignmentProductProperties(product,consignment){
    var properties = {
      product: product,
      consignment: consignment
    }
    return properties;
  }

  returnConsignmentProductStatusProperties(consignmentProduct,product){
    var properties = {
      consignmentproduct: consignmentProduct.id,
      quantity: product.stock,
      status: 6
    }
    return properties;
  }

  returnConsignmentProperties(consignment){
    var properties = {
      date: consignment.date?consignment.date:new Date(),
      barcode: consignment.barcode
    }
    if (consignment.id){
      properties['id'] = consignment.id;
      properties['total_consignment_amount'] = consignment.total_consignment_amount;
    }else{
      properties['person'] = consignment.person.id;
      properties['nif'] = consignment.nif;
      properties['name'] = consignment.name;
      properties['surname'] = consignment.surname;
      properties['address'] = consignment.address;
      properties['cp'] = consignment.cp;
      properties['town'] = consignment.town;
      properties['state'] = consignment.state;
      properties['born_date'] = consignment.born_date;
      properties['total_consignment_amount'] = consignment.total_consignment_amount;
    }
    return properties;
  }

  returnProductProperties(product){
    var properties = {
      type: product.type,
      brand: product.brand,
      model: product.model,
      storage_capacity: product.storage_capacity,
      status: product.status,
      serial_number: product.serial_number,
      charger: product.charger,
      case: product.case,
      original_box: product.original_box,
      description: product.description,
      purchase_price: product.purchase_price,
      sale_price: product.sale_price,
      stock: product.stock,
      telephone_company: product.telephone_company,
      imei: product.imei,
      imei2: product.imei2,
      accessories: product.accessories,
      so: product.so,
      cpu: product.cpu,
      ram: product.ram,
      pin: product.pin
    }
    if (product.id){
      properties['id'] = product.id;
    }
    return properties;
  }

  generateBarcodeNumber(nif, id){
    return new Promise((resolve, reject) => {
      let barcode = '3';
      let params = {
        where: {nif:nif},
        sort: 'id ASC'
      };
      id = id.toString();
      for (let i=id.length; i<6; i++){
        id = '0'+id;
      }
      this.consignmentService.query(params).subscribe((consignments) => {
        let consignmentsCount = '0';
        if (consignments.length > 0){
          let barcode = consignments[consignments.length -1].barcode;
          consignmentsCount = (parseInt(barcode.substr(barcode.length - 5)) + 1).toString();
        }
        for (let i=consignmentsCount.length; i<5; i++){
          consignmentsCount = '0'+consignmentsCount;
        }
        resolve(barcode + id + consignmentsCount);
      });
    });
  }

  markAsPrinted(){
    var consignment= {
      id: this.consignment.id,
      printed: true
    }
    this.consignmentService.update(consignment)
      .subscribe((consignment) => {
        this.getConsignment();
      });
  }

  loadFile(url,callback){
    JSZipUtils.getBinaryContent(url,callback);
  }
  

  base64DataURLToArrayBuffer(dataURL) {
    const string_base64 = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    var binary_string;
    binary_string = new Buffer(string_base64, 'base64').toString('binary');
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      var ascii = binary_string.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes.buffer;
  };


  getConsigmentDate(){
    let dateObj=this.consignment.createdAt;
    let month=moment(dateObj).lang("es").format('MMMM');
    let hour=moment(dateObj).format('HH:mm');
    let day =moment(dateObj).format('DD');
    let year =moment(dateObj).format('YYYY');
    this.consignment.newdate= day+ " de " + month + " de " + year+',' +  " a las "+ hour + " horas. ";
    return this.consignment.newdate;  
  }

  download(){

    var opts = {
      centered : false,
      // getImage :function(tagValue, tagName) {
      //   try {
      //     var fileContents = fs.readFileSync(tagValue);
      //   } catch (err) {
      //     console.log(err);
      //     // Here you get the error when the file was not found,
      //     // but you also get any other error
      //   }
      //   console.log(fs.readFileSync(tagValue))
      //   return fs.readFileSync(tagValue);
      // },
      getImage: function(image){
        return image;
      },
    
      getSize: function(img,tagValue, tagName) {
    if (tagName == 'imageCB'){
          return [100,33];}
           if (tagName == 'barcode'){
          return [100,33]
       }else{
        return [300,204];
       }
      
      }

    }

    var imageModule=new ImageModule(opts);
    var _this = this;
   
    this.loadFile("assets/consignment_template.docx",function(error,content){
      if (error) { throw error };
      var zip = new JSZip(content);
      var doc=new Docxtemplater()
              .attachModule(imageModule)
              .loadZip(zip)
    
      var products = [];
      _this.consignmentProducts.forEach(function (consignmentProduct){
        products.push(consignmentProduct.product)
      })
            
      doc.setData({
          products: products,
          imageCB:_this.base64DataURLToArrayBuffer(_this.consignment.barcode_img.substring(0,_this.consignment.barcode_img.length-1)),
          number:_this.consignment.id != undefined? _this.consignment.id: '',
          telephone2:_this.consignment.person.telephone != undefined? _this.consignment.person.telephone: '',
          cp:_this.consignment.person.cp != undefined? _this.consignment.person.cp: '',
          newdate:_this.getConsigmentDate(),
          consignment: [
            {
            first_name: _this.consignment.person.name != undefined? _this.consignment.person.name+' '+_this.consignment.person.surname: '',
            born_date: _this.consignment.person.born_date?moment(_this.consignment.person.born_date).format("DD-MM-YYYY"):'',
            NIF:_this.consignment.person.nif != undefined? _this.consignment.person.nif:'',
            address:_this.consignment.person.address != undefined? _this.consignment.person.address:'',
            town:_this.consignment.person.town != undefined? _this.consignment.person.town:'',
            state:_this.consignment.person.state != undefined? _this.consignment.person.state:'',
            address_shop:_this.consignment.shop.address != undefined? _this.consignment.shop.address:'',
            telephone_shop:_this.consignment.shop.telephone != undefined? _this.consignment.shop.telephone:'',
            attended:_this.consignment.createdByNameAndSurname != undefined? _this.consignment.createdByNameAndSurname:''
            } 
        ]
          });
      try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
      }
      catch (error) {
          var e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
          }
          console.log(JSON.stringify({error: e}));
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
      }

      var out=doc.getZip().generate({
          type:"blob",
          mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }) //Output the document using Data-URI
      //saveAs(out,"output.docx")
      FileSaver.saveAs(out, 'consigna.docx');  
      _this.markAsPrinted();     
  })


  }


}



// WEBPACK FOOTER //
// ./src/app/consignment/components/view-consignment/view-consignment.component.ts